import React from 'react';
import { useSelector } from 'react-redux';

import { CoreLink } from '@uncinc/react-drupal-core';

import {
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import Truncate from 'react-truncate';

import {
  CONTENT_IMAGE_VERTICAL_PLACEHOLDER,
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
} from '../../../../config/constants';

import './style.scss';

const TaxonomyThemeTeaser = ({ entity, className }) => {
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  const title = entity.getIn(['name', 0, 'value'], '');
  const summary = entity.getIn(['field_body', 0, 'processed'], null);
  const body = entity.getIn(['description', 0, 'processed'], '');
  const bodyStripped = body.replace(/(<([^>]+)>)/ig, '');
  const url = entity.getIn(['paths', currentLanguage], '/');
  const image = entity.getIn(['field_image', 0, 'styles'], null);

  return (
    <article className="TaxonomyThemeTeaser">
      <CoreLink to={url} className="TaxonomyThemeTeaser__link">
        <div className="TaxonomyThemeTeaser__image">
          {image ? (
            <Image
              lazyload
              includeWebP
              alt={title}
              src={{
                [SCREEN_MOBILE]: image.getIn(['crop_3_4']),
                [SCREEN_TABLET]: image.getIn(['crop_3_4']),
                [SCREEN_NORMAL]: image.getIn(['crop_3_4']),
              }}
            />
          ) : <img src={CONTENT_IMAGE_VERTICAL_PLACEHOLDER} alt="Content placeholder" />}
          <div className="overlay" />
          <div className="content">
            <h2>{title}</h2>
            <i className="icon icon-arrow-right-filled icon-variant-2" />
          </div>
          <div className="bodytext">
            <div className="inner">
              <h2>{title}</h2>
              {body && (
                <Truncate className="truncate" lines={3} ellipsis="...">
                  <WysiwygField
                    property="schema:text"
                    html={(summary !== '' ? summary : bodyStripped)} />
                </Truncate>
              )}
              <i className="icon icon-arrow-right-filled icon-variant-2" />
            </div>
          </div>
        </div>
      </CoreLink>
    </article>
  );
};

export default TaxonomyThemeTeaser;
